// extracted by mini-css-extract-plugin
export default {"wrapper":"OP3pBT"};